import { PROJECT_MODEL_LIMIT } from 'src/constants/limits';
import {
  RDFS_LABEL_IRI,
  RULE_CONTENT_IRI,
  RULE_SPARQL_RULE_IRI,
} from 'src/templates/queries/iris';
import { BindingResult } from 'src/templates/queries/types';

export type ModelRulesBindingResult = {
  iri: BindingResult;
  ruleContent: BindingResult;
  ruleLabel?: BindingResult;
};

/**
 * Determines the rules given model.
 *
 * Used to snapshot the model information of a given reasoning schema.
 *
 * **Call Frequency**
 *
 * Called once when a model is added to a project.
 *
 * **Context**
 * - Named graphs: set by the user (default is `reasoning.schema.graphs` value,
 *   which by default is `tag:stardog:api:context:local`)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# Model Rules
SELECT * {
  ?iri a <tag:stardog:api:rule:SPARQLRule> ;
    <tag:stardog:api:rule:content> ?ruleContent .
  OPTIONAL {
    ?iri <http://www.w3.org/2000/01/rdf-schema#label> ?ruleLabel .
  }
}
LIMIT 100000
 * ```
 */
export const modelRulesQuery = `# Model Rules
SELECT * {
  ?iri a <${RULE_SPARQL_RULE_IRI}> ;
    <${RULE_CONTENT_IRI}> ?ruleContent .
  OPTIONAL {
    ?iri <${RDFS_LABEL_IRI}> ?ruleLabel .
  }
}
LIMIT ${PROJECT_MODEL_LIMIT}`;
